import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/index.vue'
// import Banner from '../views/Banner.vue'
// import About from '../views/About.vue'
// import Alies from '../views/Alies.vue'
// import Community from '../views/Community.vue'
// import Regtech from '../views/Regtech.vue'
// import Solutions from '../views/Solutions.vue'
// import Verticals from '../views/Verticals.vue'
// import Why from '../views/Why.vue'
// import Work from '../views/Work.vue'
import Blog from '../views/blog/'
import BlogItem from '../views/blog/item'
import About from '../views/about/'
import Suite from '../views/suite/'
import Modules from '../views/modules/'

Vue.use(VueRouter)

const routes = [
  {path:'/',name:'home', component: home},
  {path:'/about',name:'About', component:About},
  {path:'/alies',name:'Alies', hash:'#Alies'},
  {path:'/community',name:'Community', hash:'#Community'},
  {path:'/regtech',name:'Regtech', hash:'#Regtech'},
  {path:'/solutions',name:'Solutions', hash:'#Solutions'},
  {path:'/verticals',name:'Verticals', hash:'#Verticals'},
  {path:'/why',name:'Why', hash:'#Why'},
  {path:'/work',name:'Work', hash:'#Work'},
  {path:'/blog',name:'blog', component:Blog},
  {path:'/noticia/:name',name:'noticia', component:BlogItem,  props: { post: {} }},
  {path:'/evento/:name',name:'evento', component:BlogItem,  props: { post: {} }},
  {path:'/lanzamiento/:name',name:'lanzamiento', component:BlogItem,  props: { post: {} }},
  {path:'/suite/:name',name:'suite', component:Suite,  props: { post: {} }},
  {path:'/modules/:name',name:'modules', component:Modules},
]

const router = new VueRouter({
  routes,
  scrollBehavior (to) {
    if (to.hash) {
      return {
        selector: to.hash
        // , offset: { x: 0, y: 10 }
      }
    }else{
      return { x: 0, y: 0 }
    }
  }
})

// router.beforeEach((to) => {
//   document.title = `Ceptinel Regtech ${to.hash}`
// })

export default router
